import React from "react";

const NewsContent = ({ news }) => {
  return (
    <section className="bg-white py-2 lg:py-4">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-10">

        {/* Intro */}
        {news.introText && (
          <div className="mb-6 border-l-4 border-[#E94907] pl-6">
            <p className="text-[17px] md:text-lg leading-8 text-gray-700">
              {news.introText}
            </p>
          </div>
        )}

        {/* Sections */}
        <div>
          {news.sections?.map((section, index) => (
            <div
              key={index}
              className="mb-8 last:mb-0"
            >
              {/* Heading */}
              <h2 className="text-2xl md:text-3xl font-bold text-[#172554] mb-2 leading-tight">
                {section.heading}
              </h2>

              {/* Paragraph */}
              <p className="text-[17px] leading-7 text-gray-700 whitespace-pre-line text-justify">
                {section.content}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default NewsContent;